module.exports = __webpack_public_path__ + "img/hero-background.9004b54d.png";